import store from "@/store/index";
import axios from "axios";

let baseUrlNew = process.env.VUE_APP_API_BASE_URL || "";

if (!baseUrlNew) {
  baseUrlNew =
    process.env.NODE_ENV === "production"
      ? "https://kenlyser.kenscio.in:3000" // Production URL
      : "http://localhost:3000"; // Development URL
}

axios.defaults.baseURL = baseUrlNew;
axios.defaults.withCredentials = true;

console.log("API Base URL:", baseUrlNew);

export const buildAuthHeaders = () => {
  const token = store.getters; //  Use Vuex getter to fetch the latest token
  return {
    Authorization: token ? `Bearer ${token}` : "",
    "Content-Type": "application/json",
  };
};

export { axios, baseUrlNew };